'use client'
import { Country, State } from 'country-state-city'
import { useEffect, useMemo } from 'react'
import { UseFormSetValue } from 'react-hook-form'

export function useCountryState(
  selectedCountry: string,
  setValue: UseFormSetValue<any>,
) {
  // List of countries
  const countries = useMemo(
    () =>
      Country.getAllCountries().map((c) => ({
        label: c.name,
        value: c.isoCode, // e.g., "US"
      })),
    [],
  )

  // List of states based on selected country
  const states = useMemo(() => {
    if (!selectedCountry) return []
    return State.getStatesOfCountry(selectedCountry).map((s) => ({
      label: s.name,
      value: s.isoCode, // e.g., "CA"
    }))
  }, [selectedCountry])

  // Reset state when country changes
  useEffect(() => {
    setValue('state', '')
  }, [selectedCountry, setValue])

  return { countries, states }
}
